(() => {
const $80545390e8862da1$var$settings = window.drupalSettings?.dehnMeilisearchQuick ?? {};
const $80545390e8862da1$var$lang = $80545390e8862da1$var$settings.lang ?? document.documentElement.lang;
const $80545390e8862da1$var$locale = $80545390e8862da1$var$settings.productLocale;
const $80545390e8862da1$var$country = $80545390e8862da1$var$settings.productCountry;
const $80545390e8862da1$var$PAGES_INDEX = $80545390e8862da1$var$settings.contentIndex ?? '';
const $80545390e8862da1$var$CONTENT_FILTER = $80545390e8862da1$var$settings.contentFilter ?? [];
const $80545390e8862da1$var$PRODUCTS_INDEX = $80545390e8862da1$var$settings.productsIndex ?? 'stibo-product-data-v1';
if ($80545390e8862da1$var$settings.useMeilisearch) // Direct multi-search fetch for all supported languages
$80545390e8862da1$var$initFetchSearch();
else // Fallback to DehnSearch for unsupported languages (zh-hans, ja)
$80545390e8862da1$var$initDehnSearch();
function $80545390e8862da1$var$clearResults() {
    document.getElementById('hits-pages-wrapper').hidden = true;
    document.getElementById('hits-products-wrapper').hidden = true;
    const noResults = document.getElementById('search-no-results');
    if (noResults) noResults.hidden = true;
}
function $80545390e8862da1$var$renderNoResults(hasResults) {
    const noResults = document.getElementById('search-no-results');
    if (!noResults) return;
    noResults.hidden = hasResults;
}
function $80545390e8862da1$var$renderPages(total, hits, moreHref) {
    const wrapper = document.getElementById('hits-pages-wrapper');
    const container = document.getElementById('hits-pages');
    const heading = document.getElementById('hits-pages-heading');
    if (total === 0) {
        wrapper.hidden = true;
        return;
    }
    heading.textContent = Drupal.t('Results for content (@count)', {
        '@count': total
    });
    container.textContent = '';
    hits.forEach(({ url: url, text: text })=>{
        const a = document.createElement('a');
        a.href = url;
        a.textContent = text;
        container.appendChild(a);
    });
    let moreLink = document.getElementById('pages__view-more-link');
    if (!moreLink) {
        moreLink = document.createElement('a');
        moreLink.id = 'pages__view-more-link';
        moreLink.classList.add('button', 'ic-ellipsis', 'right');
        wrapper.appendChild(moreLink);
    }
    moreLink.href = moreHref;
    moreLink.textContent = Drupal.t('More');
    wrapper.hidden = false;
}
function $80545390e8862da1$var$renderProducts(total, hits, moreHref) {
    const wrapper = document.getElementById('hits-products-wrapper');
    const container = document.getElementById('hits-products');
    const heading = document.getElementById('hits-products-heading');
    if (total === 0) {
        wrapper.hidden = true;
        return;
    }
    heading.textContent = Drupal.t('Results for products (@count)', {
        '@count': total
    });
    container.textContent = '';
    hits.forEach(({ url: url, text: text })=>{
        const a = document.createElement('a');
        a.href = url;
        a.textContent = text;
        container.appendChild(a);
    });
    let moreLink = document.getElementById('products__view-more-link');
    if (!moreLink) {
        moreLink = document.createElement('a');
        moreLink.id = 'products__view-more-link';
        moreLink.classList.add('button', 'ic-ellipsis', 'right');
        wrapper.appendChild(moreLink);
    }
    moreLink.href = moreHref;
    moreLink.textContent = Drupal.t('More');
    wrapper.hidden = false;
}
function $80545390e8862da1$var$createSearchInput(onSubmit) {
    const searchboxEl = document.getElementById('searchbox');
    if (!searchboxEl) return;
    const input = document.createElement('input');
    input.type = 'search';
    input.className = 'dehn-fw-form-field';
    input.placeholder = Drupal.t('Enter your search term...');
    searchboxEl.appendChild(input);
    let debounceTimer;
    input.addEventListener('input', ()=>{
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(()=>{
            const query = input.value.trim();
            if (query) onSubmit(query);
            else $80545390e8862da1$var$clearResults();
        }, 200);
    });
}
// Direct fetch-based search
function $80545390e8862da1$var$initFetchSearch() {
    const MEILISEARCH = $80545390e8862da1$var$settings.searchUrl;
    $80545390e8862da1$var$createSearchInput(submitSearch);
    async function submitSearch(query) {
        const baseQuery = {
            q: query,
            limit: 4,
            offset: 0,
            attributesToCrop: [
                'description:50'
            ],
            cropMarker: '...'
        };
        const payload = {
            queries: [
                {
                    ...baseQuery,
                    indexUid: $80545390e8862da1$var$PAGES_INDEX,
                    filter: $80545390e8862da1$var$CONTENT_FILTER
                },
                {
                    ...baseQuery,
                    indexUid: $80545390e8862da1$var$PRODUCTS_INDEX,
                    filter: [
                        '(salesStatus NOT IN [05,90]) AND articleURL EXISTS AND articleURL IS NOT EMPTY AND articleURL IS NOT NULL AND imageURL EXISTS AND imageURL IS NOT EMPTY AND imageURL IS NOT NULL AND familyName EXISTS AND familyName IS NOT EMPTY AND familyName IS NOT NULL AND typeName EXISTS AND typeName IS NOT EMPTY AND typeName IS NOT NULL AND articleId EXISTS AND articleId IS NOT EMPTY AND articleId IS NOT NULL AND language="' + $80545390e8862da1$var$locale + '" AND country="' + $80545390e8862da1$var$country + '"'
                    ]
                }
            ]
        };
        const response = await fetch(MEILISEARCH, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${$80545390e8862da1$var$settings.apiKey}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!result.results) return;
        const contentData = result.results.find((r)=>r.indexUid === $80545390e8862da1$var$PAGES_INDEX);
        const productData = result.results.find((r)=>r.indexUid === $80545390e8862da1$var$PRODUCTS_INDEX);
        $80545390e8862da1$var$renderPages(contentData?.estimatedTotalHits ?? 0, (contentData?.hits ?? []).map((hit)=>({
                url: hit.url.replace('/' + $80545390e8862da1$var$lang + '/', '/' + $80545390e8862da1$var$lang.toLowerCase() + '/'),
                text: (hit.metaTitle || hit.title) + (hit.metaDescription ? ` | ${hit.metaDescription}` : '')
            })), `${$80545390e8862da1$var$settings.pagesMoreUrl}&q=${encodeURIComponent(query)}`);
        $80545390e8862da1$var$renderProducts(productData?.estimatedTotalHits ?? 0, (productData?.hits ?? []).map((hit)=>({
                url: hit.articleURL,
                text: hit.articleId ? `${hit.productName} | ${Drupal.t('Part No.')} ${hit.articleId}` : hit.productName
            })), `${$80545390e8862da1$var$settings.productsMoreUrl}&q=${encodeURIComponent(query)}`);
        $80545390e8862da1$var$renderNoResults(contentData?.estimatedTotalHits > 0 || productData?.estimatedTotalHits > 0);
    }
}
// DehnSearch fallback (zh-hans, ja)
function $80545390e8862da1$var$initDehnSearch() {
    const baseUrl = `/store/s?locale=${$80545390e8862da1$var$lang}`;
    $80545390e8862da1$var$createSearchInput(submitDehnSearch);
    async function submitDehnSearch(query) {
        const searchUrl = new URL(baseUrl, window.location.origin);
        searchUrl.searchParams.set('mode', 'quick');
        searchUrl.searchParams.set('format', 'json');
        searchUrl.searchParams.set('limit', 4);
        searchUrl.searchParams.set('q', query);
        const data = await fetch(searchUrl).then((res)=>res.json());
        $80545390e8862da1$var$renderPages(data.contentHits ?? 0, data.hits.filter((h)=>h.category === 'content').map((h)=>({
                url: h.url,
                text: h.name
            })), `${$80545390e8862da1$var$settings.pagesMoreUrl}&q=${encodeURIComponent(query)}`);
        $80545390e8862da1$var$renderProducts(data.hierarchyHits ?? 0, data.hits.filter((h)=>h.category === 'hierarchy').map((h)=>({
                url: h.url,
                text: h.name
            })), `${$80545390e8862da1$var$settings.productsMoreUrl}&q=${encodeURIComponent(query)}`);
        $80545390e8862da1$var$renderNoResults(data.contentHits > 0 || data.hierarchyHits > 0);
    }
}

})();
//# sourceMappingURL=app.js.map
